import {Stack, Typography} from "@mui/material";
import React from "react";
import {addExpense, Expense, formatCurrency, formatDate, getExpenseCatTextFromSN} from "../../../firebase/index.js";
import type {APXBaseOption, APXOptions} from "../../../reusables/APXMoreMenuWithPopover.jsx";
import APXMoreMenuWithPopover from "../../../reusables/APXMoreMenuWithPopover.jsx";
import {singleLineText} from "../../../reusables/js/APXCrucialStyles.js";
import {expenseColour} from "../../../reusables/js/APXTheme.js";
import AddNewExpenseBSL from "./AddNewExpenseBSL.jsx";


export default function ExpenseCard({uid, industryKey, e}: { uid: string, industryKey: string, e: Expense }) {
	  
	  const {expenseMillis, expenseSerialNumber, expenseDetails, expenseCost, expenseKey} = (e: Expense);
	  
	  const [openNewExpenseDialog, setOpenNewExpenseDialog] = React.useState(false);
	  
	  const menuOptions: APXOptions = {
			 edit: {
					label: "Edit",
					needsConfirmation: false,
					keepDisabled: false,
					onClick: () => {
						  setOpenNewExpenseDialog(true);
					}
			 },
			 delete: {
					label: "Delete",
					needsConfirmation: true,
					keepDisabled: false,
					onClick: React.useCallback(() => {
						  addExpense(uid, industryKey, expenseKey, null);
					}, [uid, industryKey, expenseKey])
			 }
	  };
	  
	  return (
				 <>
						<Stack direction={"row"} alignItems={"start"} justifyContent={"stretch"}>
							  <Stack direction={{xs: "column", md: "row"}} width={"100%"} my={0.5} spacing={0.5} justifyContent={"space-between"}>
									 <Typography variant="body2" sx={{fontFamily: "Monospace", opacity: 0.85}} width={{md: "15%"}} style={singleLineText}>{formatDate(expenseMillis)}</Typography>
									 <Typography variant="body2" sx={{fontFamily: "Monospace", opacity: 0.65}} width={{md: "15%"}}>{getExpenseCatTextFromSN(expenseSerialNumber)}</Typography>
									 <Typography variant="body2" sx={{fontFamily: "Monospace"}} width={{md: "50%"}}>{expenseDetails}</Typography>
									 <Typography variant="body2" sx={{fontFamily: "Monospace"}} color={expenseColour} width={{md: "15%"}} style={singleLineText}>{formatCurrency(expenseCost)}</Typography>
							  </Stack>
							  <Stack direction="row" alignItems="center" justifyContent={"end"}>
									 <APXMoreMenuWithPopover options={menuOptions} onConfirmedOptionSelected={(option: APXBaseOption) => option.onClick()}/>
							  </Stack>
						</Stack>
						{openNewExpenseDialog &&
								  <AddNewExpenseBSL exp={e} uid={uid} industryKey={industryKey} onClose={() => setOpenNewExpenseDialog(false)}/>
						}
				 </>
	  );
}
